export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-1239afac7a05dfb27b53b33986580d11.svg";